var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.994,
    r: 9.392
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.994,
    r: 4.436
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.907,4.033l-2.838,4.059c.862.458,1.557,1.18,1.962,2.072l4.065-2.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.904,7.31l4.063,2.858c.405-.892,1.099-1.614,1.96-2.073l-2.837-4.058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.093,19.967l2.844-4.068c-.862-.457-1.557-1.177-1.964-2.067l-4.069,2.863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.096,16.69l-4.067-2.862c-.406.89-1.1,1.61-1.961,2.068l2.843,4.067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2337f9b0c416b9d8a9d7f24d6a0befe2.svg";
export { ForwardRef as ReactComponent };